<div class="rebalance-gen-info-header editorHeaderBanner editorDisplayBanner1">
  <div class="row">
    <div class="col item item-1">
        <div class="row flex-vertical-baseline">
        <div class="form-label flex-vertical-center">
          <span class="rebalance-name-descr">Rebalance Type</span>

        </div>
        <div class="rebalTypeDropdown form-group">
          <irb-dropdown-filter #IrbSelectedRebalanceTypeDropdown
                               id="irbSelectedRebalanceTypeDropdown"
                               [value]="selectedRebalanceType.value"
                               [size]="28"
                               (search)="setChainTypeOptions($event)"
                               (selection)="selectOption($event)"
                               [disabled]="rebalanceTypeDisabled"
                               tabindex="1"
          ></irb-dropdown-filter>
            <div class="rebalance-suggestion-txt flex-vertical-center" >
                <a class="show-rebalance-type-info" (click)="showRebalanceTypeInfo();">
                    <img src="../../assets/images/popup.png" style="vertical-align: text-top;">
                    What are the iRebal rebalance types?
                </a>
            </div>
        </div>
      </div>
    </div>
    <div class="col item item-2">
      <div class="row flex-vertical-baseline">
        <div class="form-label">
          <span class="rebalance-name-descr">Rebalance Name</span>
        </div>
        <div class="form-group">
          <div>
                  <irb-validation-text-box #analysisNameField  tabindex="2" [max]="100"
                  [(value)]="data.analysisName" [disabled]="data.isSysSuggestion || isReadOnly"
                  (change)="onGeneralInfoChange()" width="100%">
                </irb-validation-text-box>
          </div>
          <div class="rebalance-suggestion-txt flex-vertical-center">
            <p-checkbox  [disabled]="isReadOnly" name="isSysSuggestion"
              [(ngModel)]="data.isSysSuggestion" (onChange)="useSuggestedAnalysisName();" binary="true"
              inputId="rebSuggestedName">
            </p-checkbox>
            <label for="rebSuggestedName" style="padding-left: .2rem;">Use iRebal's suggested name</label>
            <span class="tooltipIconLeft infoIcon suggested-name" calltoaction
              [calltoactionTemplate]="rebalInfoToolTipIcon"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="col item item-3">
      <div class="row">
        <div class="form-label flex-vertical-center">
          <span class="rebalance-name-descr">Trade Explanation
            <span class="tooltipIconLeft infoIcon rebal-info-trade-explanation-icon" calltoaction
                  [calltoactionTemplate]="rebalInfoTradeExplaination">
            </span>
          </span>

        </div>
        <div class="form-group rebal-info-trade-explanation">
          <irb-validation-text-box #tradeExplnField
                  [(value)]="data.tradeExpln" [disabled]="isReadOnly" tabindex="3" max="255" invalidMessage="The value entered is not valid."
                  (change)="onGeneralInfoChange()" width="100%">
                </irb-validation-text-box>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #rebalInfoToolTipIcon>
  <div>
    iRebal will provide a default rebalance name, consisting of the following: <br>
    - Rebalance type <br>
    - Portfolio name (if single portfolio) or "multiple portfolios" <br>
    - Date created <br>
  </div>
</ng-template>
<ng-template #rebalInfoTradeExplaination>
  <div>This field can be used to enter rationale or other notes and will be
       retained with the rebalance results. You will also be able to edit the
       note for any portfolio in the rebalance when reviewing
       the individual results.
  </div>
</ng-template>
